import { GameParams } from "supercell-frontend-base/src/validation/game-params";
import { z } from "zod";

export const RogueGameParamsSchema = GameParams;

export type RogueGameParams = z.infer<typeof RogueGameParamsSchema>;
